<template>
  <div>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div class="my-4">
          <v-row class="bg-white mx-0">
            <v-col cols="12" class="text-center">
              <h1>{{ $t('receipt.title') }}</h1>
            </v-col>
            <v-col cols="10">
              <v-row>
                <v-col cols="6">
                  <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.startDate)" :placeholder="$t('date')"
                        outlined dense hide-details readonly v-bind="attrs" v-on="on"
                        :label="$t('from_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.startDate" no-title locale="th" @input="menuStartDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" offset-y
                    max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :value="$helper.datelabel(formData.endDate)" :placeholder="$t('date')"
                        outlined dense hide-details readonly v-bind="attrs" v-on="on"
                        :label="$t('to_date')"></v-text-field>
                    </template>
                    <v-date-picker v-model="formData.endDate" no-title locale="th" @input="menuEndDate = false"
                      :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                      :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="2" class="text-center">
              <v-btn @click="initData()" class="primary" block :disabled="isLoading">
                <v-icon>mdi-magnify</v-icon>
                {{ $t('search') }}
              </v-btn>
            </v-col>
            <template v-if="isFristTime">
              <v-col cols="12" class="text-center grey lighten-4 pt-10">
                <h4 class="text-gray-400">{{ $t('validate.please_select_date_and_search') }}</h4>
              </v-col>
            </template>
            <template v-if="!isFristTime">
              <v-col cols="12" class="text-center pt-5 grey lighten-4">
                <h2>
                  <b>{{ $t('date_list') }}</b> {{ $helper.datelabel(tempDate.startDate) }} -
                  {{ $helper.datelabel(tempDate.endDate) }}
                </h2>
                <div class="text-end py-3">
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="blue white--text mx-1"
                        :disabled="isLoading || isDownloading"
                        :loading="isLoadingExportToERP"
                      >
                        <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                        Export to ERP
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="exportSAGEReceipt()">
                        <v-list-item-title>SAGE</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="exportMangoReceipt()">
                        <v-list-item-title>Mango</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-btn
                    :disabled="isLoading"
                    @click="exportReceipt()"
                    class="blue white--text mx-1"
                    :loading="isLoadingExportExcel"
                  >
                    <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                    Export Excel
                  </v-btn>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="blue white--text mx-1"
                        :disabled="isLoading"
                        v-bind="attrs"
                        v-on="on"
                        :loading="isLoadingReportVat"
                      >
                        <v-icon class="me-2">mdi-file-excel-outline</v-icon>
                        {{ $t('tax.tax_sell_report') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="initReportVat('default_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('default_non_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_total_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('split_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_tax_split_market') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="initReportVat('split_non_group')">
                        <v-list-item-title>{{ $t('tax.tax_sell_report_split_tax_total_market') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu v-if="!isShowSelectPrintReceipt">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="blue white--text mx-1" :disabled="isLoading" v-bind="attrs" v-on="on">
                        <v-icon left> mdi-printer </v-icon>
                        {{ $t('bill.print_receipt') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="printReceipt('all')">
                        <v-list-item-title>{{ $t('bill.print_all') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="choosePrintReceipt('select')">
                        <v-list-item-title>{{ $t('bill.select_bill') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <template v-else>
                    <v-btn class="info mx-1" @click="printReceipt('select')"
                      :disabled="isLoading || selectedReceipts.length <= 0">
                      <v-icon left> mdi-printer </v-icon>
                      {{ $t('bill.print_bill', { count: selectedReceipts.length }) }}
                    </v-btn>
                  </template>
                  <v-btn v-show="isShowSelectPrintReceipt" class="error mx-1"
                    @click="selectedReceipts = []; isShowSelectPrintReceipt = false;">
                    {{ $t('cancel') }}
                  </v-btn>
                </div>
              </v-col>
              <v-col v-if="!isFirstLoading" cols="12" class="px-0 pt-0 pb-4 grey lighten-4">
                <v-data-table 
                  v-if="dataTable && dataTable.data"
                  :headers="dataTable.headers"
                  :items="dataTable.data"
                  :items-per-page="10"
                  class="elevation-1 data-table-receipt"
                  item-key="objectId"
                  @click:row="rowClick"
                  v-model="selectedReceipts"
                  :show-select="isShowSelectPrintReceipt"
                  :single-select="false"
                  ref="projectDataTableReceipt"
                  :loading="isLoading"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                  }"
                  :no-data-text="$t('noinfo')"
                  :no-results-text="$t('no_matching_records_found')"
                >

                  <template v-slot:header.marketName="{ header }">
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{ header.text }}</div>
                  </template>
                  <template v-slot:header.areaName="{ header }">
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{ header.text }}</div>
                  </template>
                  <template v-slot:header.customerDataName="{ header }">
                    <div class="text-nowrap-table text-center" style="min-width: 150px;">{{ header.text }}</div>
                  </template>

                  <template v-slot:body.prepend>
                    <tr>
                      <td class="text-center" :colspan="isShowSelectPrintReceipt ? 2 : 1">
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.marketName" type="text" :label="$t('market.market')" solo dense hide-details :disabled="isLoading" />
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.documentId" type="text" :label="$t('market.document_id')" solo dense
                          hide-details :disabled="isLoading" />
                      </td>
                      <td class="ps-0">
                        <v-select v-model="filterData.documentType" :items="filterOption.documentType" type="text"
                          :label="$t('type')" solo dense hide-details clearable :disabled="isLoading" :no-data-text="$t('noinfo')"/>
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.areaName" type="text" :label="$t('market.market_title')" solo dense hide-details :disabled="isLoading" />
                      </td>
                      <td class="ps-0">
                        <v-text-field v-model="filterData.customerName" type="text" :label="$t('market.marchant_name')" solo dense
                          hide-details :disabled="isLoading" />
                      </td>
                      <td class="ps-0 pe-0">
                        <v-currency-field v-model="filterData.totalValue" class="input-right input-disable-appearance"
                          :label="$t('market.total_value')" solo dense hide-details :disabled="isLoading" />
                      </td>
                      <td :class="$helper.currencyOptions.length <= 1 ? 'd-none' : ''">
                        <v-select v-model="filterData.currencyCode" :items="$helper.currencyOptions" item-text="textThEn" item-value="value" type="text" :label="$t('payment.currency')" 
                        solo dense hide-details clearable :disabled="isLoading" 
                        :no-data-text="$t('noinfo')" />
                      </td>
                      <td>
                        <v-select v-model="filterData.status" :items="filterOption.status" type="text" :label="$t('status')" solo
                          dense hide-details clearable :disabled="isLoading" :no-data-text="$t('noinfo')"/>
                      </td>
                      <td>
                        <v-select v-model="filterData.paymentMethod" :items="filterOption.paymentMethod" value="value"
                          type="text" :label="$t('payment.payment_method')" solo dense hide-details clearable multiple :disabled="isLoading" :no-data-text="$t('noinfo')"/>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-slot:item.data-table-select="{ isSelected, select, item }">
                    <template v-if="isShowSelectPrintReceipt && item.isPaid">
                      <v-simple-checkbox color="primary" :value="isSelected"
                        @input="select($event)"></v-simple-checkbox>
                    </template>
                  </template>
                  <!-- @click:row="onTableRowClick" -->
                  <template v-slot:item.date="{ item }">
                    <template v-if="item.date">
                      {{ $moment(item.date).format("DD/MM/YYYY") }}
                    </template>
                  </template>
                  <template v-slot:item.documentId="{ item }">
                    <div class="d-flex align-center">
                      <img v-if="item.refAccId && item.isPaid" class="me-1" width="18"
                        :src="require(`@/assets/images/flowaccount.svg`)" />
                      {{ item.documentId }}
                    </div>
                  </template>
                  <template v-slot:item.documentTypeString="{ item }">
                    <div class="text-no-wrap text-start">{{ item.documentTypeString }}</div>
                  </template>
                  <template v-slot:item.marketName="{ item }">
                    <div class="text-truncate text-start market-name">{{ item.marketName }}</div>
                  </template>
                  <template v-slot:item.areaName="{ item }">
                    <div class="text-truncate text-start area-name">{{ item.areaName }}</div>
                  </template>
                  <template v-slot:item.customerDataName="{ item }">
                    <div class="text-truncate text-start customer-name">{{ item.customerDataName }}</div>
                  </template>
                  <template v-slot:item.dueDate="{ item }">
                    <template v-if="item.dueDate">
                      {{ $moment(item.dueDate).format("DD/MM/YYYY") }}
                    </template>
                  </template>
                  <template v-slot:item.status="{ item }" class="text-center">
                    <v-chip class="red--text" color="rgb(248,218,218)" v-if="!item.isPaid && !item.documentId">{{
                      $t('payment.pending') }}</v-chip>
                    <v-chip class="grey--text" color="rgb(240,242,246)" v-if="!item.isPaid && item.documentId">{{
                      $t('payment.cancel_payment') }}</v-chip>
                    <v-chip class="green--text" color="rgb(209,242,225)" v-if="item.isPaid">{{ $t('payment.paid')
                    }}</v-chip>
                  </template>
                  <template v-slot:item.totalValue="{ item }">
                    <div class="text-end">
                      {{ item.totalValue | currency }}
                    </div>
                  </template>
                  <template v-slot:item.currencyCode="{ item }">
                    <div class="text-center">
                      {{ $helper.currencyThEn(item.currencyCode || 'THB') }}
                    </div>
                  </template>
                  <template v-slot:item.paymentMethod="{ item }">
                    <div>{{ item.paymentMethodText }}</div>
                  </template>
                  <template v-slot:item.note="{ item }">
                    <v-tooltip left color="success" v-if="!item.isPaid && item.cancelledNote">
                      <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
                          <img :src="require(`@/assets/images/notepad-info.svg`)" :alt="$t('note')" />
                        </div>
                      </template>
                      <div style="max-width: 330px;">
                        <span><b>{{ $t('bill.receipt') }} {{ item.documentId }}: </b> {{ item.cancelledNote }}</span>
                      </div>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
              <v-col v-else>
                <v-card class="d-flex justify-center py-10">
                  <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
                </v-card>
              </v-col>
            </template>

          </v-row>
          <!-- <ReceiptSummary v-if="!isLoading" :receipts="currentReceipts" /> -->
        </div>

        <template v-if="!isLoading && paymentMethodType">
          <div class="my-5">
            <template v-if="$helper.currencyOptions.length > 1">
              <v-tabs
                v-model="tab"
                color="primary"
                slider-color="primary"
                background-color="white"
                class="tab-custom-inline">
                <template v-for="currency in $helper.currencyOptions">
                  <v-tab :value="currency.value" :href="`#${currency.value}`" :key="currency.value">
                    <img :src="`/images/currency/${currency.value}.svg`" :alt="currency.value" class="mr-2 tab-icon-flag">
                    {{ currency.tabName }}
                  </v-tab>
                </template>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item key="THB" value="THB">
                  <CardReceiptOverAll  class="p-3" :paymentMethodType="paymentMethodType" :tabType="`THB`" :countReceipt="countReceiptTH"/>
                </v-tab-item>
                <v-tab-item key="LAK" value="LAK">
                  <CardReceiptOverAll  class="p-3" :paymentMethodType="paymentMethodType" :tabType="`LAK`" :countReceipt="countReceiptLAK"/>
                </v-tab-item>
                <v-tab-item key="USD" value="USD">
                  <CardReceiptOverAll class="p-3" :paymentMethodType="paymentMethodType" :tabType="`USD`" :countReceipt="countReceiptUSD"/>
                </v-tab-item>
              </v-tabs-items>
            </template>
            <template v-else>
              <v-card elevation="0">
                <CardReceiptOverAll :paymentMethodType="paymentMethodType" :tabType="tab" :countReceipt="countReceipt"/>
              </v-card>
            </template>
          </div>
        </template>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <ReceiptDialog v-if="tempReceipt" v-model="isReceiptDialog" :receiptId="tempReceipt.objectId"
      :projectId="projectId" />
    <PrintDialog elementId="print-receipt-project-accounting" type="receipt" v-model="isPrintDialog"
      :receiptIds="selectedReceipts.map(d => d.objectId)" />
    <v-dialog v-model="isPrintReportVat" v-if="isPrintReportVat" width="1000" @keydown.esc="isPrintReportVat = false"
      persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center blue white--text py-2">
          <template>{{ $t('tax.tax_sell_report') }}</template>
        </v-card-title>
        <iframe width="100%" height="500px" frameborder="0" name="iframe-report-vat" id="iframe-report-vat"></iframe>
        <div style="display: none;">
          <div style="height: 500px; overflow: scroll; font-family: 'Sarabun' !important;" id="report-vat-data">
            <template
              v-if="isEmpty(receiptVatGroup) && isEmpty(receiptNonGroup) && (typeSelectReceipt == 'default_group' || typeSelectReceipt == 'default_non_group')">
              <div class="paper A4" v-for="(mk, index) in markets" :key="'paper_' + index">
                <template v-if="typeOnButtonReceipt == 'showFirstMarket'">
                  <template v-if="index == 0">
                    <section class="sheet" id="sheet">
                      <div class="page" style="padding: 5mm; font-size: 13px;">
                        <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                          <tr>
                            <td>{{ $t('tax.tax_sell_report') }}</td>
                            <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                          </tr>
                        </table>
                        <table width="100%" style="font-weight: bold; font-size: 13px;">
                          <tr>
                            <td width="20%">{{ $t('market.business_owner_name') }}</td>
                            <td>
                              <template v-if="mk.companyData && mk.companyData.name">
                                {{ mk.companyData.name }}
                              </template>
                              <template v-else>
                                {{ mk.name }}
                              </template>
                            </td>
                            <td width="20%">
                              <div
                                v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              <div v-else
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.main_office') }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('market.business_name') }}</td>
                            <td>
                              <template v-if="mk.companyData && mk.companyData.name">
                                {{ mk.companyData.name }}
                              </template>
                              <template v-else>
                                {{ mk.name }}
                              </template>
                            </td>
                            <td>
                              <template
                                v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                <div
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                              </template>
                              <template v-else>
                                <div
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                {{ $t('market.branch_office_number', {
                                  number: mk.companyData ?
                                    mk.companyData.branchName : ''
                                }) }}
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                            <td></td>
                          </tr>
                          <tr>
                            <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' })
                            }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                            <td class="text-center">{{ $t('receipt.print_date_range', {
                              startDate:
                                $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                                $moment(tempDate.endDate).format("DD/MM/YYYY")
                            })
                            }}</td>
                            <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                            </td>
                          </tr>
                        </table>
                        <table width="100%" class="report-vat-table">
                          <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                            <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                            <th>{{ $t('number') }}</th>
                            <th>{{ $t('customer.customer_and_service_name') }}</th>
                            <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                            <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                            <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                            <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                          </tr>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                          <tr>
                            <td colspan="4"></td>
                            <td class="text-center"><b>{{ $t('sum') }}</b></td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                            <td class="text-right">{{ 0 | currency }}</td>
                          </tr>
                        </table>
                        <div style="border-top: 1px solid black; margin-top: 10px">
                          ({{ $t('receipt.receipt_count', { count: 0 }) }})
                        </div>
                      </div>
                    </section>
                  </template>
                </template>
                <template v-else-if="typeOnButtonReceipt == 'showAllMarket'">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="mk.companyData && mk.companyData.name">
                              {{ mk.companyData.name }}
                            </template>
                            <template v-else>
                              {{ mk.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="mk.companyData && mk.companyData.name">
                              {{ mk.companyData.name }}
                            </template>
                            <template v-else>
                              {{ mk.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', {
                                number: mk.companyData ? mk.companyData.branchName
                                  : ''
                              }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' }) }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', {
                            startDate:
                              $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                              $moment(tempDate.endDate).format("DD/MM/YYYY")
                          })
                          }}</td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                          </td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <tr>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-center">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                          <td class="text-right">-</td>
                        </tr>
                        <tr>
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                          <td class="text-right">{{ 0 | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: 0 }) }})
                      </div>
                    </div>
                  </section>
                </template>
              </div>            
            </template>

            <template
              v-if="isEmpty(receiptVatGroup) && isEmpty(receiptNonGroup) && (typeSelectReceipt == 'split_group' || typeSelectReceipt == 'split_non_group')">
              <template v-for="chunk in 2">
                <template v-for="(mk, index) in markets">
                  <div class="paper A4" v-if="typeOnButtonReceipt == 'showFirstMarket' && index == 0">
                    <template>
                      <section class="sheet" id="sheet">
                        <div class="page" style="padding: 5mm; font-size: 13px;">
                          <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                            <tr>
                              <td>{{ $t('tax.tax_sell_report') }}</td>
                              <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" style="font-weight: bold; font-size: 13px;">
                            <tr>
                              <td width="20%">{{ $t('market.business_owner_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td width="20%">
                                <div
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                <div v-else
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.main_office') }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('market.business_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td>
                                <template
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-blank-outline</title>
                                      <path
                                        d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                                </template>
                                <template v-else>
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-outline</title>
                                      <path
                                        d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', {
                                    number: mk.companyData ?
                                      mk.companyData.branchName : ''
                                  }) }}
                                </template>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' })
                              }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                              <td class="text-center">{{ $t('receipt.print_date_range', {
                                startDate:
                                  $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                                  $moment(tempDate.endDate).format("DD/MM/YYYY")
                              }) }}
                              </td>
                              <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                              </td>
                            </tr>
                          </table>
                          <table width="100%" class="report-vat-table">
                            <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                              <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                              <th>{{ $t('number') }}</th>
                              <th>{{ $t('customer.customer_and_service_name') }}</th>
                              <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                              <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                              <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                            </tr>
                            <tr>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </tr>
                            <tr>
                              <td colspan="4"></td>
                              <td class="text-center"><b>{{ $t('sum') }}</b></td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                            </tr>
                          </table>
                          <div style="border-top: 1px solid black; margin-top: 10px">
                            ({{ $t('receipt.receipt_count', { count: 0 }) }})
                          </div>
                        </div>
                      </section>
                    </template>
                  </div>

                  <template v-else-if="typeOnButtonReceipt == 'showAllMarket'">
                    <div class="paper A4">
                      <section class="sheet" id="sheet">
                        <div class="page" style="padding: 5mm; font-size: 13px;">
                          <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                            <tr>
                              <td>{{ $t('tax.tax_sell_report') }}</td>
                              <td class="text-right">{{ $t('page_message', { page: 1, total: 1 }) }}</td>
                            </tr>
                          </table>
                          <table width="100%" style="font-weight: bold; font-size: 13px;">
                            <tr>
                              <td width="20%">{{ $t('market.business_owner_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td width="20%">
                                <div
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'"
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-outline</title>
                                    <path
                                      d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                  </svg>
                                </div>
                                <div v-else
                                  style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <title>checkbox-blank-outline</title>
                                    <path
                                      d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                  </svg>
                                </div>
                                {{ $t('market.main_office') }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('market.business_name') }}</td>
                              <td>
                                <template v-if="mk.companyData && mk.companyData.name">
                                  {{ mk.companyData.name }}
                                </template>
                                <template v-else>
                                  {{ mk.name }}
                                </template>
                              </td>
                              <td>
                                <template
                                  v-if="!mk.companyData || !mk.companyData.branchName || mk.companyData.branchName == 'สำนักงานใหญ่'">
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-blank-outline</title>
                                      <path
                                        d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                                </template>
                                <template v-else>
                                  <div
                                    style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                      <title>checkbox-outline</title>
                                      <path
                                        d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                    </svg>
                                  </div>
                                  {{ $t('market.branch_office_number', {
                                    number: mk.companyData ?
                                      mk.companyData.branchName : ''
                                  }) }}
                                </template>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                              <td>{{ mk.companyData ? mk.companyData.address : '' }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="3">{{ $t('tax.tax_id', { taxId: mk.companyData ? mk.companyData.taxId : '' })
                              }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                              <td class="text-center">{{ $t('receipt.print_date_range', {
                                startDate:
                                  $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                                  $moment(tempDate.endDate).format("DD/MM/YYYY")
                              }) }}
                              </td>
                              <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                              </td>
                            </tr>
                          </table>
                          <table width="100%" class="report-vat-table">
                            <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                              <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                              <th>{{ $t('number') }}</th>
                              <th>{{ $t('customer.customer_and_service_name') }}</th>
                              <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                              <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                              <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                              <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                            </tr>
                            <tr>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-center">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </tr>
                            <tr>
                              <td colspan="4"></td>
                              <td class="text-center"><b>{{ $t('sum') }}</b></td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                              <td class="text-right">{{ 0 | currency }}</td>
                            </tr>
                          </table>
                          <div style="border-top: 1px solid black; margin-top: 10px">
                            ({{ $t('receipt.receipt_count', { count: 0 }) }})
                          </div>
                        </div>
                      </section>
                    </div>
                  </template>
                </template>
              </template>
            </template>

            <template v-if="receiptVatGroup">
              <div v-for="(rct, inx) in receiptVatGroup">
                <div class="paper A4" v-for="(checks, index) in rct.chunk" :key="'paper_' + index">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', { page: index + 1, total: rct.chunk.length }) }}
                          </td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="rct.market.companyData && rct.market.companyData.name">
                              {{ rct.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ rct.market.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!rct.market.companyData || !rct.market.companyData.branchName || rct.market.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="rct.market.companyData && rct.market.companyData.name">
                              {{ rct.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ rct.market.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!rct.market.companyData || !rct.market.companyData.branchName || rct.market.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', {
                                number: rct.market.companyData ?
                                  rct.market.companyData.branchName : ''
                              }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ rct.market.companyData ? rct.market.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', {
                            taxId: rct.market.companyData ?
                              rct.market.companyData.taxId : ''
                          }) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', {
                            startDate:
                              $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                              $moment(tempDate.endDate).format("DD/MM/YYYY")
                          }) }}
                          </td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                          </td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <template v-if="checks.length > 0">
                          <tr v-for="(receipt) in checks" :key="receipt.objectId" style="vertical-align: baseline;">
                            <td class="text-center">{{ $moment(receipt.date).format("DD/MM/YYYY") }}</td>
                            <td>{{ receipt.documentId }}</td>
                            <td>
                              <span v-if="receipt.isPaid && receipt.isCreditNote">
                                {{ $t('receipt.return_money_and_discount') }}
                                {{ receipt.invoice.documentId }}
                              </span>
                              <span v-else-if="receipt.isPaid && !receipt.isCreditNote">
                                {{ receipt.customerData.name }}
                              </span>
                              <span v-else>
                                ** CANCELLED **
                              </span>
                            </td>
                            <td class="text-center"><span>{{ receipt.customerData.taxId || "-" }}</span></td>
                            <td class="text-center">
                              <template
                                v-if="receipt.contract && receipt.contract.customer && receipt.contract.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="receipt.booking && receipt.booking.customer && receipt.booking.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="receipt.contractCheckOut && receipt.contractCheckOut.contract && receipt.contractCheckOut.contract.customer && receipt.contractCheckOut.contract.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                            </td>
                            <td class="text-right">
                              <template v-if="receipt.isPaid && receipt.isCreditNote">
                                {{ receipt.totalNonVatItemsValue * -1 | currency }}
                              </template>
                              <template v-else-if="receipt.totalNonVatItemsValue && receipt.isPaid">
                                {{ receipt.totalNonVatItemsValue | currency }}
                              </template>
                              <template v-else>-</template>
                            </td>
                            <template v-if="receipt.isPaid && receipt.isCreditNote">
                              <td class="text-right">{{ receipt.totalVatItemsValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue * -1 | currency }}</td>
                            </template>
                            <template v-else-if="receipt.isPaid">
                              <td class="text-right">{{ receipt.totalVatItemsValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue | currency }}</td>
                            </template>
                            <template v-else>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                        </template>
                        <tr v-if="rct.chunk.length > 0 && index == rct.chunk.length - 1">
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ rct.summary.totalNonVatItemsValue | currency }}</td>
                          <td class="text-right">{{ rct.summary.totalVatItemsValue | currency }}</td>
                          <td class="text-right">{{ rct.summary.totalVatValue | currency }}</td>
                          <td class="text-right">{{ rct.summary.totalValue | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: checks ? checks.length : 0 }) }})
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </template>
            <template v-if="receiptNonGroup">
              <div v-for="(rct_nonvat, inx) in receiptNonGroup">
                <div class="paper A4" v-for="(checks, index) in rct_nonvat.chunk" :key="'paper_nonvat_' + index">
                  <section class="sheet" id="sheet">
                    <div class="page" style="padding: 5mm; font-size: 13px;">
                      <table width="100%" style="font-weight: bold; font-size: 13px;margin-bottom: 7px;">
                        <tr>
                          <td>{{ $t('tax.tax_sell_report') }}</td>
                          <td class="text-right">{{ $t('page_message', {
                            page: index + 1, total: rct_nonvat.chunk.length
                          }) }}</td>
                        </tr>
                      </table>
                      <table width="100%" style="font-weight: bold; font-size: 13px;">
                        <tr>
                          <td width="20%">{{ $t('market.business_owner_name') }}</td>
                          <td>
                            <template v-if="rct_nonvat.market.companyData && rct_nonvat.market.companyData.name">
                              {{ rct_nonvat.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ rct_nonvat.market.name }}
                            </template>
                          </td>
                          <td width="20%">
                            <div
                              v-if="!rct_nonvat.market.companyData || !rct_nonvat.market.companyData.branchName || rct_nonvat.market.companyData.branchName == 'สำนักงานใหญ่'"
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-outline</title>
                                <path
                                  d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                              </svg>
                            </div>
                            <div v-else
                              style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <title>checkbox-blank-outline</title>
                                <path
                                  d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                              </svg>
                            </div>
                            {{ $t('market.main_office') }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ $t('market.business_name') }}</td>
                          <td>
                            <template v-if="rct_nonvat.market.companyData && rct_nonvat.market.companyData.name">
                              {{ rct_nonvat.market.companyData.name }}
                            </template>
                            <template v-else>
                              {{ rct_nonvat.market.name }}
                            </template>
                          </td>
                          <td>
                            <template
                              v-if="!rct_nonvat.market.companyData || !rct_nonvat.market.companyData.branchName || rct_nonvat.market.companyData.branchName == 'สำนักงานใหญ่'">
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-blank-outline</title>
                                  <path
                                    d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', { number: '' }) }} . . . . .
                            </template>
                            <template v-else>
                              <div
                                style="width: 20px; height: 20px; display: inline-block; position: relative; top: 5px;">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                  <title>checkbox-outline</title>
                                  <path
                                    d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,5V19H5V5H19M10,17L6,13L7.41,11.58L10,14.17L16.59,7.58L18,9" />
                                </svg>
                              </div>
                              {{ $t('market.branch_office_number', {
                                number: rct_nonvat.market.companyData ?
                                  rct_nonvat.market.companyData.branchName : ''
                              }) }}
                            </template>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>{{ rct_nonvat.market.companyData ? rct_nonvat.market.companyData.address : '' }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="3">{{ $t('tax.tax_id', {
                            taxId: rct_nonvat.market.companyData ?
                              rct_nonvat.market.companyData.taxId : ''
                          }) }}</td>
                        </tr>
                        <tr>
                          <td>{{ $t('receipt.print_date', { date: $moment().format("DD/MM/YYYY") }) }}</td>
                          <td class="text-center">{{ $t('receipt.print_date_range', {
                            startDate:
                              $moment(tempDate.startDate).format("DD/MM/YYYY"), endDate:
                              $moment(tempDate.endDate).format("DD/MM/YYYY")
                          }) }}
                          </td>
                          <td class="text-right">{{ $t('receipt.print_time', { time: $moment().format("HH:mm") }) }}
                          </td>
                        </tr>
                      </table>
                      <table width="100%" class="report-vat-table">
                        <tr style="border-top: 1px solid black;border-bottom: 1px solid black;">
                          <th class="text-center">{{ $t('date') }} {{ $t('month') }} {{ $t('year') }}</th>
                          <th>{{ $t('number') }}</th>
                          <th>{{ $t('customer.customer_and_service_name') }}</th>
                          <th class="text-center">{{ $t('tax.tax_id', { taxId: '' }) }}</th>
                          <th class="text-center">{{ $t('market.main_and_branch_office') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.no_tax') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.before_tax') }}</th>
                          <th class="text-center">{{ $t('tax.title') }}<br />{{ $t('tax.vat') }}</th>
                          <th class="text-center">{{ $t('value') }}<br />{{ $t('tax.total_tax') }}</th>
                        </tr>
                        <template v-if="checks.length > 0">
                          <tr v-for="(receipt) in checks" :key="receipt.objectId" style="vertical-align: baseline;">
                            <td class="text-center">{{ $moment(receipt.date).format("DD/MM/YYYY") }}</td>
                            <td>{{ receipt.documentId }}</td>
                            <td>
                              <span v-if="receipt.isPaid && receipt.isCreditNote">
                                {{ $t('receipt.return_money_and_discount') }}
                                {{ receipt.invoice.documentId }}
                              </span>
                              <span v-else-if="receipt.isPaid && !receipt.isCreditNote">
                                {{ receipt.customerData.name }}
                              </span>
                              <span v-else>
                                ** CANCELLED **
                              </span>
                            </td>
                            <td class="text-center"><span>{{ receipt.customerData.taxId || "-" }}</span></td>
                            <td class="text-center">
                              <template
                                v-if="receipt.contract && receipt.contract.customer && receipt.contract.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="receipt.booking && receipt.booking.customer && receipt.booking.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-else-if="receipt.contractCheckOut && receipt.contractCheckOut.contract && receipt.contractCheckOut.contract.customer && receipt.contractCheckOut.contract.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  {{ $t('market.main_office_short') }}
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                            </td>
                            <td class="text-right">
                              <template v-if="receipt.isPaid && receipt.isCreditNote">
                                {{ receipt.totalNonVatItemsValue * -1 | currency }}
                              </template>
                              <template v-else-if="receipt.totalNonVatItemsValue && receipt.isPaid">
                                {{ receipt.totalNonVatItemsValue | currency }}
                              </template>
                              <template v-else>-</template>
                            </td>
                            <template v-if="receipt.isPaid && receipt.isCreditNote">
                              <td class="text-right">{{ receipt.totalVatItemsValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue * -1 | currency }}</td>
                            </template>
                            <template v-else-if="receipt.isPaid">
                              <td class="text-right">{{ receipt.totalVatItemsValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue | currency }}</td>
                            </template>
                            <template v-else>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-center">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                          </tr>
                        </template>
                        <!-- <template v-if="checks">
                          <tr v-for="(receipt) in checks" :key="receipt.objectId">
                            <td class="text-center">{{ $moment(receipt.date).format("DD/MM/YYYY") }}</td>
                            <td>{{ receipt.documentId }}</td>
                            <td>
                              <span v-if="receipt.isPaid && receipt.isCreditNote">
                                คืนเงินประกัน ลดหนี้
                                {{ receipt.invoice.documentId }}
                              </span>
                              <span v-else-if="receipt.isPaid && !receipt.isCreditNote">
                                {{ receipt.customerData.name }}
                              </span>
                              <span v-else>
                                ** CANCELLED **
                              </span>
                            </td>
                            <td class="text-center">{{ receipt.customerData.taxId || "-" }}</td>
                            <td class="text-center">
                              <template
                                v-if="receipt.contract && receipt.contract.customer && receipt.contract.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  สนง.ใหญ่
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                              <template
                                v-if="receipt.booking && receipt.booking.customer && receipt.booking.customer.type == 'company'">
                                <template
                                  v-if="!receipt.customerData.branchName || receipt.customerData.branchName == 'สำนักงานใหญ่'">
                                  สนง.ใหญ่
                                </template>
                                <template v-else>
                                  {{ receipt.customerData.branchName }}
                                </template>
                              </template>
                            </td>
                            <td class="text-right">
                              <template v-if="receipt.isPaid && receipt.isCreditNote">
                                {{ receipt.totalNonVatItemsValue * -1 | currency }}
                              </template>
                              <template v-else-if="receipt.totalNonVatItemsValue && receipt.isPaid">
                                {{ receipt.totalNonVatItemsValue | currency }}
                              </template>
                              <template v-else>-</template>
                            </td>
                            <template v-if="receipt.isPaid && receipt.isCreditNote">
                              <td class="text-right">{{ receipt.totalVatItemsValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue * -1 | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue * -1 | currency }}</td>
                            </template>
                            <template v-else-if="receipt.isPaid">
                              <td class="text-right">{{ receipt.totalVatItemsValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalVatValue | currency }}</td>
                              <td class="text-right">{{ receipt.totalValue | currency }}</td>
                            </template>
                            <template v-else>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                              <td class="text-right">-</td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr style="border-bottom: 1px solid black;border-bottom: 1px solid black;">
                            <td class="text-center">-</td>
                            <td class="text-center">&nbsp;</td>
                            <td class="text-center">&nbsp;</td>
                            <td class="text-center">&nbsp;</td>
                            <td class="text-center">&nbsp;</td>
                            <td class="text-right">&nbsp;</td>
                            <td class="text-right">&nbsp;</td>
                            <td class="text-right">&nbsp;</td>
                            <td class="text-right">&nbsp;</td>
                          </tr>
                        </template> -->
                        <tr
                          v-if="rct_nonvat.chunk && rct_nonvat.chunk.length > 0 && index == rct_nonvat.chunk.length - 1">
                          <td colspan="4"></td>
                          <td class="text-center"><b>{{ $t('sum') }}</b></td>
                          <td class="text-right">{{ rct_nonvat.summary.totalNonVatItemsValue | currency }}</td>
                          <td class="text-right">{{ rct_nonvat.summary.totalVatItemsValue | currency }}</td>
                          <td class="text-right">{{ rct_nonvat.summary.totalVatValue | currency }}</td>
                          <td class="text-right">{{ rct_nonvat.summary.totalValue | currency }}</td>
                        </tr>
                      </table>
                      <div style="border-top: 1px solid black; margin-top: 10px">
                        ({{ $t('receipt.receipt_count', { count: checks ? checks.length : 0 }) }})
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </template>

          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" @click="isPrintReportVat = false">{{ $t('close') }}</v-btn>
          <v-btn color="info" @click="printReportVat()">
            <v-icon dark class="me-2">mdi-printer</v-icon>{{ $t('print') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import ParentBar from "@/components/ParentBar.vue";
import AccountingParentBar from "@/components/AccountingParentBar.component";
import SelectMonthYear from "@/components/SelectMonthYear.component";
import ReceiptDialog from "@/components/ReceiptDialog.component.vue";
import InvoiceDialog from "@/components/InvoiceDialog.component";
import PrintDialog from "@/components/PrintDialog.component.vue";
import ReceiptSummary from "@/components/ReceiptSummary.component.vue";
import CardReceiptOverAll from "@/components/CardReceiptOverAll.component.vue";

import { ExportSAGE, ExportAccounting, ExportMango } from "@/exports";
import BankData from "@/json/bank-data.json";
import { mapGetters } from "vuex";
import { Receipt, Market, CreditNote } from "@/classes"
export default {
  computed: {
    ...mapGetters({
      receipts: 'receipt/getReceipts',
      creditNotes: 'creditNote/getCreditNotes',
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.$route.params.projectId);
    },
    dataTable() {
      return {
        headers: [
          {
            text: this.$t('date'),
            value: "date",
            width: "8%",
            align: "center",
          },
          {
            text: this.$t('market.market'),
            value: "marketName",
            width: "1%",
            class: 'custom-sort',
            align: 'center hd-resize',
            filter: d =>
              this.filterData.marketName ? d.toLowerCase().includes(this.filterData.marketName.toLowerCase()) : d
          },
          {
            text: this.$t('market.document_id'),
            value: "documentId",
            width: "12%",
            align: "center",
            filter: d =>
              this.filterData.documentId ? d.toLowerCase().includes(this.filterData.documentId.toLowerCase()) : d
          },
          {
            text: this.$t('type'),
            width: "12%",
            value: "documentTypeString",
            align: "center",
            filter: d =>
              this.filterData.documentType ? d == this.filterData.documentType : d
          },
          {
            text: this.$t('market.market_title'),
            width: "1%",
            value: "areaName",
            align: 'center hd-resize',
            class: 'custom-sort',
            filter: d =>
              this.filterData.areaName ? d.toLowerCase().includes(this.filterData.areaName.toLowerCase()) : d
          },
          {
            text: this.$t('market.marchant_name'),
            width: "1%",
            value: "customerDataName",
            align: 'center hd-resize',
            class: 'custom-sort',
            filter: d =>
              this.filterData.customerName ? d.toLowerCase().includes(this.filterData.customerName.toLowerCase()) : d
          },
          {
            text: this.$t('market.total_value'),
            value: "totalValue",
            width: "10%",
            align: "center",
            filter: d =>
              this.filterData.totalValue ? d.toString().includes(this.filterData.totalValue) : d || d === 0
          },
          {
            text: this.$t('payment.currency'),
            value: "currencyCode",
            width: "8%",
            align: `center ${this.$helper.currencyOptions.length <= 1 ? 'd-none' : ''}`,
            filter: d =>
              this.filterData.currencyCode ? d == this.filterData.currencyCode : d
          },
          {
            text: this.$t('status'),
            value: "status",
            align: "center",
            filter: d =>
              this.filterData.status ? d == this.filterData.status : d
          },
          {
            text: this.$t('payment.payment_method'),
            value: "paymentMethod",
            width: "8%",
            align: "center",
            filter: d =>
              this.filterData.paymentMethod && this.filterData.paymentMethod.length
                ? this.filterData.paymentMethod.includes(d)
                : d
          },
          {
            text: this.$t('note'),
            value: "note",
            width: "4%",
            align: "center",
          }
        ],
        data: this.receipts,
      };
    },
    countReceiptTH(){
      return this.receipts.filter(d => d.currencyCode == 'THB' || !d.currencyCode).length;
    },
    countReceiptUSD(){
      return this.receipts.filter(d => d.currencyCode == 'USD').length;
    },
    countReceiptLAK(){
      return this.receipts.filter(d => d.currencyCode == 'LAK').length;
    },
    countReceipt(){
      return this.receipts.filter(d => d.currencyCode == this.tab).length;
    },

  },
  data() {
    return {
      BankData,
      projectId: this.$route.params.projectId,
      isReceiptDialog: false,
      selectedMonthYear: null,
      isError: false,
      isLoading: false,
      isFirstLoading: true,
      invoiceId: null,
      menuStartDate: false,
      menuEndDate: false,
      isFristTime: true,
      formData: {
        startDate: this.$moment({ day: 1 }).format("YYYY-MM-DD"),
        endDate: this.$moment().endOf("month").format("YYYY-MM-DD"),
      },
      tempDate: null,
      tempReceipt: null,
      isShowSelectPrintReceipt: false,
      selectedReceipts: [],
      isPrintDialog: false,
      isDownloading: false,
      filterData: {
        documentId: null,
        documentType: null,
        areaName: null,
        customerName: null,
        totalValue: null,
        status: null,
        marketName: null,
        currencyCode: null
      },
      filterOption: {
        documentType: [
          {
            text: this.$t('bill.document_type.1')
          },
          {
            text: this.$t('bill.deposit_bill')
          },
          {
            text: this.$t('bill.checkin_bill')
          },
          {
            text: this.$t('payment.checkout_bill')
          },
          {
            text: this.$t('bill.other_bill')
          },
          {
            text: this.$t('payment.installment_bill')
          },
          {
            text: this.$t('payment.daily_booth')
          },
          {
            text: this.$t('payment.monthly_booking')
          }
        ],
        status: [
          {
            text: this.$t('payment.paid')
          },
          {
            text: this.$t('payment.cancel_payment')
          },
        ],
        paymentMethod: [
          {
            text: this.$t('payment.cash'),
            value: 1
          },
          {
            text: this.$t('payment.bank_transfer'),
            value: 2
          },
          {
            text: this.$t('payment.debit_credit'),
            value: 3
          },
          {
            text: this.$t('payment.bill_payment'),
            value: 4
          },
          {
            text: this.$t('payment.deposit_deduction'),
            value: 5
          },
          {
            text: this.$t('payment.cash_check'),
            value: 6
          },
          {
            text: this.$t('payment.qr_payment'),
            value: 7
          },
          {
            text: this.$t('payment.gift_voucher'),
            value: 8
          },
        ],
      },
      paymentMethodType: null,
      paymentMethodTypeColor: {
        [this.$t('payment.paid')]: "bg-green-100 green--text",
        [this.$t('payment.cancel_payment')]: "bg-dark-gray dark--text",
        [this.$t('payment.pending')]: "bg-red-100 red--text"
      },
      paymentMethodTypeBoxColor: {
        [this.$t('payment.cancel_payment')]: "border-gray order-2",
        [this.$t('payment.paid')]: "border-green order-1",
        [this.$t('payment.pending')]: "border-red"
      },
      currentReceipts: [],
      isPrintReportVat: false,
      receiptNonGroup: {},
      receiptVatGroup: {},
      typeOnButtonReceipt: null,
      typeSelectReceipt: null,
      tab: this.$globalCurrencyCode,
      fullExportReceipts: [],
      loadedExportReceipts: false,
      isLoadingExportToERP: false,
      isLoadingExportExcel: false,
      isLoadingReportVat: false,
    };
  },
  watch: {
    filterData: {
      handler(val) {
        if (this.$refs.projectDataTableReceipt && this.$refs.projectDataTableReceipt.$children[0] && this.$refs.projectDataTableReceipt.$children[0].filteredItems) {
          this.currentReceipts = this.$refs.projectDataTableReceipt.$children[0].filteredItems
          this.paymentMethodTypeFn(this.currentReceipts);
        }
      },
      deep: true,
      immediate: true
    },
    receipts: {
      handler(val) {
        setTimeout(() => {
          if (this.$refs.projectDataTableReceipt && this.$refs.projectDataTableReceipt.$children[0] && this.$refs.projectDataTableReceipt.$children[0].filteredItems) {
            this.currentReceipts = this.$refs.projectDataTableReceipt.$children[0].filteredItems
          }
        }, 10);
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    InvoiceDialog,
    SelectMonthYear,
    ParentBar,
    AccountingParentBar,
    Layout,
    ReceiptDialog,
    PrintDialog,
    ReceiptSummary,
    CardReceiptOverAll
  },
  async created() {
    this.markets = await Market.getMarketByProject(this.projectId);
    this.project = this.markets[0] ? this.markets[0].project : null;
  },
  methods: {
    async initData() {
      this.isLoading = true;
      this.isFirstLoading = true;
      this.receiptNonGroup = {};
      this.receiptVatGroup = {};
      this.isFristTime = false
      this.loadedExportReceipts = false;
      this.fullExportReceipts = [];
      this.$store.commit("receipt/setReceiptExport", []);
      try {
        this.tempDate = JSON.parse(JSON.stringify(this.formData));
        this.invoicesSelect = [
          "documentId",
          "documentType",
          "paymentMethod",
          "customerData",
          "market.name",
          "contract",
          "date",
          "isPaid",
          "isSent",
          "totalValue",
          "items.area.name",
          "currencyCode",
          "currencyRate"
        ]
        let params = {
          projectId: this.projectId,
          startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.formData.endDate).endOf("day").toISOString(),
        }
        this.$store.commit("receipt/setReceipts", []);
        let [, creditNotes] = await Promise.all([
          this.$helper.queryMore(
            Receipt.getReceiptsBetweenDateByProject,
            {...params, select: this.invoicesSelect, isRaw: true},
            null,
            (results) => {
              this.$store.commit("receipt/addReceipts", results);
              this.isFirstLoading = false;
            }
          ),
          this.$helper.queryMore(
            CreditNote.getCreditNotesBetweenDateByProject,
            params,
          )
        ])
        this.$store.commit("creditNote/setCreditNotes", creditNotes);
        this.paymentMethodTypeFn();
        this.isFirstLoading = false;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.isFirstLoading = false;
        this.isError = true;
      }
    },
    groupByObjectId(array) {
      return array.reduce((acc, item) => {
        const key = item.market.objectId;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});
    },
    onSaveSuccess() {
      this.paymentMethodTypeFn();
    },
    async exportSAGEReceipt() {
      this.isDownloading = true
      this.isLoadingExportToERP = true;
      try {
        const fullReceipts = await this.getFullExportReceipts();
        const receipts = fullReceipts.filter(d => { return d.isPaid })
        await ExportSAGE.exportReceiptZip(receipts);
        this.isDownloading = false
      } catch (error) {
        this.isDownloading = false
        this.isError = true
      } finally {
        this.isLoadingExportToERP = false;
      }
    },
    paymentMethodTypeFn(rcIn = null) {
      let rct = {};
      let receipts = [];
      if (rcIn) receipts = rcIn;
      else receipts = this.receipts;

      if (receipts && receipts.length > 0) {
        this.filterOption.createdBy = []
        for (const receipt of receipts) {
          const currencyCode = receipt.currencyCode || 'THB';
          if (!rct[currencyCode]) {
            rct[currencyCode] = {};
            rct[currencyCode][this.$t('payment.paid')] = { sum: 0, data: {}, countIsPaid: 0, countCancelled: 0 };
            rct[currencyCode][this.$t('payment.cancel_payment')] = { sum: 0, data: {}, countIsPaid: 0, countCancelled: 0 };
          }

          if (!this.filterOption.createdBy.find(cd => cd.text == receipt.createdByText)) {
            this.filterOption.createdBy.push(receipt.createdByText);
          }

          const status = receipt.status === this.$t('payment.paid') ? receipt.status : this.$t('payment.cancel_payment');

          rct[currencyCode][status].sum += parseFloat(receipt.totalValue);
          if(receipt.isPaid) rct[currencyCode][status].countIsPaid++;
          if(!receipt.isPaid) rct[currencyCode][status].countCancelled++;

          let paymentMethod = receipt.paymentMethodText;
          if (!rct[currencyCode][status].data[paymentMethod]) {
            rct[currencyCode][status].data[paymentMethod] = {
              data: [],
              sum: 0,
              type: {}
            };
          }

          if (rct[currencyCode][status].data && rct[currencyCode][status].data[paymentMethod]) {
            rct[currencyCode][status].data[paymentMethod].data.push(receipt);
            rct[currencyCode][status].data[paymentMethod].sum += parseFloat(receipt.totalValue);
          }

          if (
            rct[currencyCode][status].data &&
            rct[currencyCode][status].data[this.$t('payment.cash')] &&
            paymentMethod == this.$t('payment.cash') &&
            receipt.createdByText
          ) {
            if (!rct[currencyCode][status].data[this.$t('payment.cash')].type[receipt.createdByText]) {
              rct[currencyCode][status].data[this.$t('payment.cash')].type[receipt.createdByText] = {
                sum: 0
              };
            }
            rct[currencyCode][status].data[this.$t('payment.cash')].type[receipt.createdByText].sum += parseFloat(receipt.totalValue);
          }

          if (
            rct[currencyCode][status].data &&
            rct[currencyCode][status].data[this.$t('payment.bank_transfer')] &&
            paymentMethod == this.$t('payment.bank_transfer') &&
            receipt.paymentBankAccount &&
            receipt.paymentBankAccount.accountNumber
          ) {
            if (!rct[currencyCode][status].data[this.$t('payment.bank_transfer')].type[receipt.paymentBankAccount.accountNumber]) {
              rct[currencyCode][status].data[this.$t('payment.bank_transfer')].type[receipt.paymentBankAccount.accountNumber] = { 
                sum: 0,
                data: []
              };
            }
            rct[currencyCode][status].data[this.$t('payment.bank_transfer')].type[receipt.paymentBankAccount.accountNumber].data = receipt.paymentBankAccount;
            rct[currencyCode][status].data[this.$t('payment.bank_transfer')].type[receipt.paymentBankAccount.accountNumber].sum += parseFloat(receipt.totalValue);
          }

          if (
            rct[currencyCode][status].data &&
            rct[currencyCode][status].data[this.$t('payment.cash_check')] &&
            paymentMethod == this.$t('payment.cash_check') &&
            receipt.paymentBankAccount &&
            receipt.paymentBankAccount.accountNumber
          ) {
            if (!rct[currencyCode][status].data[this.$t('payment.cash_check')].type[receipt.paymentBankAccount.accountNumber]) {
              rct[currencyCode][status].data[this.$t('payment.cash_check')].type[receipt.paymentBankAccount.accountNumber] = {
                sum: 0,
                data: []
              };
            }
            rct[currencyCode][status].data[this.$t('payment.cash_check')].type[receipt.paymentBankAccount.accountNumber].data = receipt.paymentBankAccount;
            rct[currencyCode][status].data[this.$t('payment.cash_check')].type[receipt.paymentBankAccount.accountNumber].sum += parseFloat(receipt.totalValue);
          }

          if (
            rct[currencyCode][status].data &&
            rct[currencyCode][status].data[this.$t('payment.gift_voucher')] &&
            paymentMethod == this.$t('payment.gift_voucher') &&
            receipt.createdByText
          ) {
            if (!rct[currencyCode][status].data[this.$t('payment.gift_voucher')].type[receipt.createdByText]) {
              rct[currencyCode][status].data[this.$t('payment.gift_voucher')].type[receipt.createdByText] = {
                sum: 0
              };
            }
            rct[currencyCode][status].data[this.$t('payment.gift_voucher')].type[receipt.createdByText].sum += parseFloat(receipt.totalValue);
          }
        }
      }
      this.paymentMethodType = rct;
      return rct;
    },
    hashing(datas) {
      let hash = {}
      for (let data of datas) {
        hash[data.objectId] = data
      }
      return hash
    },
    rowClick(receipt) {
      this.tempReceipt = receipt
      this.isReceiptDialog = true;
    },
    getAreaName(items) {
      let name = [];
      for (let item of items) {
        if (item.area && item.area.name) {
          name.push(item.area.name);
        }
      }
      return [...new Set(name)].join(",") || "-";
    },
    choosePrintReceipt() {
      this.selectedReceipts = [];
      this.isShowSelectPrintReceipt = true;
    },
    printReceipt(type) {
      let filterReceipts = this.$refs.projectDataTableReceipt.$children[0].filteredItems
      if (type == "all") {
        this.selectedReceipts = filterReceipts.filter((d) => d.isPaid);
      }
      this.isPrintDialog = true;
    },
    async exportReceipt() {
      this.isLoading = true;
      this.isLoadingExportExcel = true;
      try {
        const filterReceipts = this.$refs.projectDataTableReceipt.$children[0].filteredItems
        const ids = new Set(filterReceipts.map(d => d.objectId))
        const fullReceipts = await this.getFullExportReceipts();
        const exportReceipts = fullReceipts.filter(rc => ids.has(rc.objectId))
        ExportAccounting.exportReceiptList(
          exportReceipts,
          this.formData.startDate,
          this.formData.endDate,
          this.paymentMethodType,
          this.$globalVatPercent
        )
      } catch (err) {
        this.isError = true
      } finally {
        this.isLoadingExportExcel = false;
        this.isLoading = false;
      }
    },
    printReportVat() {
      var PDF = document.getElementById("iframe-report-vat");
      PDF.focus();
      try {
        PDF.contentWindow.print();
      } catch (ex) {
        PDF.contentWindow.postMessage("print", "*");
      }
    },
    splitChunk(_data) {
      let data = []
      let i = 0
      let chunk = []
      for (let receipt of _data) {
        chunk.push(receipt)
        i++;
        if (receipt.customerData?.name?.length > 28 || (receipt.isPaid && receipt.isCreditNote) || (receipt.customerData && receipt.customerData.branchName && receipt.customerData.branchName != this.$t('market.main_office') && receipt.customerData.branchName.length > 10)) i++;
        if (i >= 45) {
          data.push(chunk)
          chunk = []
          i = 0
        }
      }
      if (chunk.length) data.push(chunk)
      return data.length ? data : []
    },
    splitChunkNonData(_data) {
      let data = []
      let i = 0
      let chunk = []
      for (let market of _data) {
        chunk.push(market)
        i++;
        if (i >= 1) {
          data.push(chunk)
          chunk = []
          i = 0
        }
      }
      if (chunk.length) data.push(chunk)
      return data.length ? data : []
    },
    summaryDataRepotVat(_data) {
      let totalNonVatItemsValue = 0
      let totalVatItemsValue = 0
      let totalVatValue = 0
      let totalValue = 0
      if (_data) {
        for (let receipt of _data) {
          if (receipt.isPaid && receipt.isCreditNote) {
            totalNonVatItemsValue -= receipt.totalNonVatItemsValue
            totalVatItemsValue -= receipt.totalVatItemsValue
            totalVatValue -= receipt.totalVatValue
            totalValue -= receipt.totalValue
          } else if (receipt.isPaid) {
            totalNonVatItemsValue += receipt.totalNonVatItemsValue
            totalVatItemsValue += receipt.totalVatItemsValue
            totalVatValue += receipt.totalVatValue
            totalValue += receipt.totalValue
          }
        }
      }
      return {
        totalNonVatItemsValue,
        totalVatItemsValue,
        totalVatValue,
        totalValue
      }
    },
    summaryDataRepotVatNonVat(_data) {
      let totalNonVatItemsValue = 0
      let totalVatItemsValue = 0
      let totalVatValue = 0
      let totalValue = 0
      if (_data) {
        for (let receipt of _data) {
          if (receipt.isPaid && receipt.isCreditNote) {
            totalNonVatItemsValue -= receipt.totalNonVatItemsValue
            totalVatItemsValue -= receipt.totalVatItemsValue
            totalVatValue -= receipt.totalVatValue
            totalValue -= receipt.totalValue
          } else if (receipt.isPaid) {
            totalNonVatItemsValue += receipt.totalNonVatItemsValue
            totalVatItemsValue += receipt.totalVatItemsValue
            totalVatValue += receipt.totalVatValue
            totalValue += receipt.totalValue
          }
        }
      }
      return {
        totalNonVatItemsValue,
        totalVatItemsValue,
        totalVatValue,
        totalValue
      }
    },
    async initReportVat(type) {
      this.isLoading = true;
      this.isLoadingReportVat = true;
      const _receipts = this.$refs.projectDataTableReceipt.$children[0].filteredItems
      const ids = new Set(_receipts.map(d => d.objectId))
      const fullReceipts = await this.getFullExportReceipts();
      let receipts = fullReceipts.filter(d => ids.has(d.objectId)).map(d => new Receipt(d.data, true))
      receipts = receipts.concat(this.creditNotes)
      this.receiptVatGroup = {};
      this.receiptNonGroup = {};
      let dataVat = null;
      let dataNonVat = null;
      this.typeSelectReceipt = type;
      if (type == "split_group") {
        dataVat = this.groupByObjectId(receipts.filter(d => d.isCreditNote ? d.totalVatValue * -1 : d.totalVatValue))
        dataNonVat = this.groupByObjectId(receipts.filter(d => d.isCreditNote ? !d.totalVatValue * -1 : !d.totalVatValue))
      } else if (type == "split_non_group") {
        dataVat = receipts.filter(d => d.isCreditNote ? d.totalVatValue * -1 : d.totalVatValue)
        dataNonVat = receipts.filter(d => d.isCreditNote ? !d.totalVatValue * -1 : !d.totalVatValue)
      } else if (type == "default_group") {
        dataVat = this.groupByObjectId(receipts)
        dataNonVat = null;
      } else if (type == "default_non_group") {
        dataVat = receipts
        dataNonVat = null;
      }

      if (receipts && receipts.length > 0) {
        if (type == "split_group" || type == "default_group") {
          if (dataVat) {
            for (let key in dataVat) {
              if (!this.receiptVatGroup[key]) {
                this.receiptVatGroup[key] = {
                  receipts: [],
                  chunk: [[]],
                  market: null,
                  summary: null,
                }
              }
              this.receiptVatGroup[key].receipts = dataVat[key];
              this.receiptVatGroup[key].chunk = this.splitChunk(dataVat[key]);
              this.receiptVatGroup[key].market = dataVat[key][0].market;
              this.receiptVatGroup[key].summary = this.summaryDataRepotVat(dataVat[key]);
            }
            for (let mk of this.markets) {
              if (!this.receiptVatGroup[mk.objectId]) {
                this.receiptVatGroup[mk.objectId] = {
                  receipts: [],
                  chunk: [[]],
                  market: mk,
                  summary: this.summaryDataRepotVat(),
                }
              }
            }
          }
          if (dataNonVat) {
            for (let key in dataNonVat) {
              if (!this.receiptNonGroup[key]) {
                this.receiptNonGroup[key] = {
                  receipts: [],
                  chunk: [[]],
                  market: null,
                  summary: null,
                }
              }
              this.receiptNonGroup[key].receipts = dataNonVat[key];
              this.receiptNonGroup[key].chunk = this.splitChunk(dataNonVat[key]);
              this.receiptNonGroup[key].market = dataNonVat[key][0].market;
              this.receiptNonGroup[key].summary = this.summaryDataRepotVatNonVat(dataNonVat[key]);
            }
            for (let mk of this.markets) {
              if (!this.receiptNonGroup[mk.objectId]) {
                this.receiptNonGroup[mk.objectId] = {
                  receipts: [],
                  chunk: [[]],
                  market: mk,
                  summary: this.summaryDataRepotVatNonVat(),
                }
              }
            }
          }
        } else {
          if (dataVat) {
            this.receiptVatGroup = [
              {
                receipts: dataVat,
                chunk: this.splitChunk(dataVat),
                market: this.markets[0],
                summary: this.summaryDataRepotVat(dataVat)
              }
            ]
            this.receiptVatGroup[0].market.name = this.project.name
          }
          if (dataNonVat) {
            this.receiptNonGroup = [
              {
                receipts: dataNonVat,
                chunk: this.splitChunk(dataNonVat),
                market: this.markets[0],
                summary: this.summaryDataRepotVatNonVat(dataNonVat)
              }
            ]
            this.receiptNonGroup[0].market.name = this.project.name
          }
        }
      } else {
        this.receiptVatGroup = {};
        this.receiptNonGroup = {};
        if (type == "split_group" || type == "default_group") {
          this.typeOnButtonReceipt = "showAllMarket"
        } else {
          this.typeOnButtonReceipt = "showFirstMarket"
        }
      }


      this.isPrintReportVat = true
      if (document.getElementById("iframe-report-vat")) {
        let PDF = document.getElementById("iframe-report-vat")
        PDF.contentWindow.document.body.innerHTML = ""
      }
      setTimeout(() => {
        let PDF = document.getElementById("iframe-report-vat")
        let data = document.getElementById("report-vat-data")
        PDF.contentWindow.document.head.innerHTML = `
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Sarabun:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
            body{
              margin: 0px;
            }
            * { 
              font-family: "Sarabun";
            }
            table {
              border-collapse: collapse;
            }
            .text-center{
              text-align: center;
            }
            .text-right{
              text-align: right;
            }
            @page { margin: 0 }
            .paper { margin: 0 }
            .sheet {
              margin: 0;
              overflow: hidden;
              position: relative;
              box-sizing: border-box;
              page-break-after: always;
            }

            /** Paper sizes **/
            .paper.A4               .sheet { width: 210mm; height: 296mm }


            /** For screen preview **/
            @media screen {
              .paper { background: #e0e0e0; padding: 5mm 0; }
              .sheet {
                background: white;
                box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
                margin: 0mm auto;
              }
            }

            /** Fix for Chrome issue #273306 **/
            @media print {
              .paper.A4, .paper.A5.landscape { width: 210mm }
            }

            table.report-vat-table {
              font-size: 12px;
              margin-top: 3px;
            }
            table.report-vat-table tr th:nth-child(1) {
              max-width:64px;
              width:64px;
            }
            table.report-vat-table tr th:nth-child(2) {
              max-width:96px;
              width:96px;
            }
            table.report-vat-table tr th:nth-child(3) {
              min-width:94px;
              max-width:200px;
            }
            table.report-vat-table tr th:nth-child(4),table.report-vat-table tr td:nth-child(4) {
              max-width:87px;
              width:87px;
            }
            table.report-vat-table tr th:nth-child(5) {
              max-width:55px;
              width:55px;
            }
            table.report-vat-table tr th:nth-child(6) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(7) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(8) {
              min-width:70px;
            }
            table.report-vat-table tr th:nth-child(9) {
              min-width:70px;
            }

            table.report-vat-table tr td{
              overflow-wrap: anywhere;
            }
              
            }
          </style>
        `
        PDF.contentWindow.document.body.innerHTML = data.innerHTML
      }, 200)
      this.isLoadingReportVat = false;
      this.isLoading = false;
    },
    async exportMangoReceipt() {
      this.isLoading = true;
      this.isLoadingExportToERP = true;
      try {
        const fullReceipts = await this.getFullExportReceipts();
        let receipts = fullReceipts.filter(d => d.isPaid);
        ExportMango.exportMango(receipts, "receipt", this.tempDate.startDate, this.tempDate.endDate);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingExportToERP = false;
        this.isLoading = false;
      }
    },
    async getFullExportReceipts() {
      if (!this.loadedExportReceipts) {
        let params = {
          projectId: this.projectId,
          startDate: this.$moment(this.formData.startDate).startOf("day").toISOString(),
          endDate: this.$moment(this.formData.endDate).endOf("day").toISOString()
        };
        this.fullExportReceipts = await this.$helper.queryMore(Receipt.getReceiptsBetweenDateByProject, params)
        this.loadedExportReceipts = true;
      }
      return this.fullExportReceipts;
    },
    isEmpty(obj) {
      return !obj || Object.keys(obj).length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.data-table-receipt::v-deep td.hd-resize {
  max-width: 150px;
}

.data-table-receipt::v-deep th.custom-sort {
  position: relative;

  .v-icon {
    position: absolute;
    right: 24px;
    top: 18px;
  }
}

.text-nowrap-table.market-name,
.text-nowrap-table.area-name,
.text-nowrap-table.customer-name {
  width: 100%;
}
</style>